import React, { Dispatch, FunctionComponent, useContext, useReducer } from 'react';
import { BootParameters } from 'src';
import { ZakekeEnvironment } from '../environment';
import Boot from './boot';
import { createProviderValue } from './createProviderValue';
import { Zakeke } from './providerValue';
import { Reducer, reducer } from './reducer';
import { AppState } from './state';

export const context = React.createContext<Zakeke | null>(null);
const internalContext = React.createContext<{ state: AppState; dispatch: Dispatch<any> } | null>(null);

// Use zakeke hook
const useInternalState = () => {
	const value = useContext(internalContext);

	if (!value) throw 'Corrupted Zakeke state';

	return value;
};

// ZakekeProvider
const ZakekeProvider: FunctionComponent<{ parameters?: BootParameters | null; environment: ZakekeEnvironment; children?: React.ReactNode | React.ReactElement }> = ({
	environment,
	parameters,
	children
}) => {
	const [state, dispatch] = useReducer<Reducer>(reducer, {
		environment,
		sceneViewer: null,
		isAddToCartLoading: false,
		isSceneLoading: false,
		parametersReceived: false,
		isDebug: false,
		customizer: null
	});

	// Create the provider value exposed to developer
	const value = createProviderValue(state, dispatch);

	return (
		<context.Provider value={value}>
			<internalContext.Provider value={{ state, dispatch }}>
				<Boot parameters={parameters}>{children}</Boot>
			</internalContext.Provider>
		</context.Provider>
	);
};

export { ZakekeProvider, useInternalState };

// Export types for external use
export type {
	AIPreset,
	AIPresetCategory,
	AIProductStagingRule,
	AIProductStagingOptions,
	AIProductStagingResult,
	AIVirtualTryOnOptions,
	AIVirtualTryOnResult,
	AIServicesAvailability,
	AIVirtualModelRule,
	AIToolUsageRule,
	AILimitPeriodType,
} from '../models';

// Export classes (runtime values)
export { AIRateLimitError } from '../models';